<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">

                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">
                                        <div class="page-body">

                                            <div class="row">
                                                <div class="col-md-12 col-xl-12">
                                                    <div class="card summery-card">
                                                        <div class="card-header">
                                                            <div class="card-header-left ">
                                                                <h5>Computer Based Test</h5>
                                                                <br>
                                                            </div>
                                                        </div>
                                                        <div class="card-block">

                                                            <button v-if="$checkPerm('process.cbt.create')" class="btn btn-primary btn-md mb-3"
                                                                data-toggle="modal" data-target="#new_cbt">
                                                                <i class="icofont icofont-plus"></i>
                                                                New CBT
                                                            </button>
                                                            &nbsp;
                                                            <button v-if="$checkPerm('process.cbt.assign_to_opening')"
                                                                class="btn btn-primary btn-md mb-3" data-toggle="modal"
                                                                data-target="#assignToOpening">
                                                                Assign CBT to Opening
                                                            </button>

                                                            <div class="table-responsive" v-if="cbt_id ==''">
                                                                <input type="text" class="form-control" v-model="cbt_filter"
                                                                    placeholder="Search...">
                                                                <datatable :columns="cbt_columns" :data="cbt_questions"
                                                                    :filter-by="cbt_filter" name="cbt_table"></datatable>
                                                                <div class="" style="text-align: center;">
                                                                    <datatable-pager v-model="page" type="long"
                                                                        :per-page="per_page" table="cbt_table"></datatable-pager>
                                                                </div>
                                                            </div>

                                                            <div v-else>
                                                                <CBTComponent v-bind:id="cbt_id" />
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="new_cbt" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">New CBT</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form v-on:submit.prevent="createCbt">
                            <div class="form-group">
                                <label>Test Name</label>
                                <input type="text" class="form-control" v-model="new_cbt.cbtname" placeholder="Test Name"
                                    required="required" />
                            </div>
                            <div class="form-group">
                                <label>Time Allowed (In Minutes)</label>
                                <input type="number" min="1" class="form-control" v-model="new_cbt.time_allowed"
                                    placeholder="Time" required="required" />
                            </div>
                            <div class="form-group">
                                <label>Test Instructions</label>
                                <textarea class="form-control test_instruction" v-model="new_cbt.instruction"
                                    placeholder="Test Instruction" required="required"></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary btn-md">Submit</button>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <div id="assignToOpening" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Assign CBT to Opening</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form role="form" v-on:submit.prevent="cbtToOpening">
                            <div class="form-group">
                                <label>Select CBT</label>
                                <select class="form-control" v-model="cbt_to_opening.cbtid" required="required">
                                    <option v-for="t in cbt_questions" v-bind:value="t.id">{{t.cbtname}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Assign to Opening</label>
                                <select class="form-control" v-model="cbt_to_opening.joblisting[0]" required="required">
                                    <option v-for="o in openings" v-bind:value="o.id">{{o.jobrole.name}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary">Assign</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<style>
    .pagination {
        display: inline-block;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        background: #d5d5d5 !important;
    }

    .pagination a.active {
        background: #4CAF50 !important;
        color: white;
    }

    .pagination a:hover:not(.active) {
        background-color: #00ff00;
    }

    .actions {
        margin-top: 30px;
    }

    .test_instruction {
        height: 200px !important;
        resize: none;
    }
</style>

<script>
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'
    import Tips from '../components/Tips.vue'
    import CBTComponent from '../components/CBT/CBTComponent.vue'

    function addCbtValues() {
        return {
            cbtname: "",
            time_allowed: "",
            instruction: ""
        }
    }

    export default {
        name: 'CBT',

        data() {
            return {
                cbt_filter: '',
                page: 1,
                per_page: 10,
                cbt_columns: [
                    { label: "ID", field: "id", sortable: true },
                    { label: "Name", field: "cbtname", sortable: true },
                    {
                        label: "Number of Questions", representedAs: (row) => {
                            return row.cbtquestions.length
                        }, sortable: true
                    },
                    {
                        label: "Action", representedAs: (row) => {
                            if (this.$checkPerm('process.cbt.view')) {
                                return '<a class="btn btn-sm btn-primary" href="/cbt/' + row.id + '">View / Modify</a>'
                            }
                        }, sortable: true, interpolate: true
                    }
                ],
                cbt_questions: [],
                cbt_id: "",
                new_cbt: addCbtValues(),
                cbt_to_opening: {
                    cbtid: "",
                    joblisting: []
                },
                openings: []
            }
        },

        components: {
            navbar1,
            navbar2,
            Tips,
            CBTComponent
        },

        mounted() {
            this.getCbt()
            this.getAllOpening()

            if (this.$route.params.id !== undefined) {
                this.cbt_id = parseInt(this.$route.params.id)
            } else {
                this.cbt_id = ''
            }
        },
        methods: {

            getCbt: function () {

                var loading_html = '<div style="height:150px;width:150px;margin: 0 auto;"><img style="width: 100%;" src="https://i.ya-webdesign.com/images/minimalist-transparent-loading-gif-6.gif" /></div>'

                this.$swal.fire({
                    title: "<h5></h5>",
                    html: loading_html,
                    showConfirmButton: false,
                    showCancelButton: false,
                    allowOutsideClick: false
                })

                var cbt = {
                    what: "CBT",
                    params: {
                        companyid: this.$store.getters.user_data.data.company_id
                    }
                }

                this.$socket.makeGetRequest(cbt)
                    .then((response) => {
                        if (response.type == 'CBT') {
                            //console.log(response)
                            this.cbt_questions = response.data
                            this.$swal.close()
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            createCbt: function () {

                this.new_cbt.company_id = this.$store.getters.user_data.data.company_id

                var add_cbt = {
                    what: 'AddCbt',
                    data: this.new_cbt
                }

                //console.log(add_cbt)

                this.$socket.makePostRequest(add_cbt)
                    .then((response) => {
                        if (response.type == 'AddCbt' && response.status == "true") {
                            this.getCbt()
                            this.$swal.fire('Success', "Test created.", 'success')
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            getAllOpening: function () {

                var get_openings_request = {
                    what: 'openings'
                }

                this.$socket.makeGetRequest(get_openings_request)
                    .then((response) => {
                        if (response.type == 'openings') {
                            //console.log(response.data)
                            this.openings = response.data
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                    })
            },

            cbtToOpening: function () {
                console.log(this.cbt_to_opening)

                let request = {
                    what: 'CbtToJoblisting',
                    data: this.cbt_to_opening
                }

                //CbtToJoblisting

                this.$socket.makePostRequest(request)
                    .then((response) => {
                        if (response.type == 'CbtToJoblisting' && response.status == "true") {
                            this.$swal.fire('Success', "CBT assigned to selected opening.", 'success')

                            this.cbt_to_opening = {
                                cbtid: "",
                                joblisting: []
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }

        },
        computed: {

        }
    }
</script>